var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/slider/common/src/slider-base-props.ts
var sliderCommonDefaultProps = {
  step: 1,
  size: "md",
  disabled: false,
  showLabels: false
};
var sliderBaseSizes = ["sm", "md", "lg"];
var sliderBaseDefaultProps = __spreadProps(__spreadValues({}, sliderCommonDefaultProps), {
  showValues: false,
  min: 0,
  max: 100
});

// components/slider/common/src/slider-props.ts
var sliderDefaultProps = __spreadProps(__spreadValues({}, sliderCommonDefaultProps), {
  showValue: false,
  minValue: 0,
  maxValue: 100
});
var sliderSizes = sliderBaseSizes;

// components/slider/common/src/slider-multiple-props.ts
var sliderMultipleDefaultProps = sliderBaseDefaultProps;
var sliderMultipleSizes = sliderBaseSizes;

// components/slider/common/src/slider-base-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var getSliderBaseRootClassNames = (props) => {
  const { cssClasses, overrideClasses, className, globalClassName } = props;
  return cx(cssClasses.root, overrideClasses && overrideClasses.root, className, globalClassName);
};
var getSliderBaseInputClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.input,
    overrideClasses && overrideClasses.input,
    `${globalClassName}__input`
  );
};
var getSliderBaseTrackContainerClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(cssClasses.trackContainer, overrideClasses && overrideClasses.trackContainer);
};
var getSliderBaseTrackClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.trackBase,
    cssClasses.track,
    overrideClasses && overrideClasses.track,
    `${globalClassName}__track`
  );
};
var getSliderBaseSelectedRangeClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.trackBase,
    cssClasses.selectedRange,
    overrideClasses && overrideClasses.range,
    `${globalClassName}__range`
  );
};
var getSliderBaseLabelValueClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    overrideClasses && overrideClasses.labelValue,
    `${globalClassName}__label`,
    `${globalClassName}__value`
  );
};
var getSliderBaseLabelMinClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    overrideClasses && overrideClasses.labelMin,
    `${globalClassName}__label`,
    `${globalClassName}__label-min`
  );
};
var getSliderBaseLabelMaxClassNames = (props) => {
  const { cssClasses, overrideClasses, globalClassName } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    overrideClasses && overrideClasses.labelMax,
    `${globalClassName}__label`,
    `${globalClassName}__label-max`
  );
};

// components/slider/common/src/slider-base-style-sheets.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { hexToRgb, isIE, isFirefox } from "@gs-ux-uitoolkit-common/shared";
var sliderBaseStyleSheet = new StyleSheet(
  "sliderBaseStyles",
  ({
    showValues,
    size,
    values,
    min,
    max,
    disabled,
    theme,
    showLabels
  }) => {
    const minVal = values[0];
    const maxVal = values[values.length - 1];
    const minPercent = minVal === void 0 ? 0 : getPercent(minVal, min, max);
    const maxPercent = maxVal === void 0 ? 100 : getPercent(maxVal, min, max);
    const sliderSize = getDimensionBySize(size);
    let thumbSelector = "&::-webkit-slider-thumb";
    if (isIE) {
      thumbSelector = "&::-ms-thumb";
    } else if (isFirefox) {
      thumbSelector = "&::-moz-range-thumb";
    }
    let appearanceSelector = "WebkitAppearance";
    if (isFirefox) {
      appearanceSelector = "MozAppearance";
    }
    return {
      root: {
        height: sliderSize,
        marginBottom: showValues !== false || showLabels !== false ? "24px" : "2px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        marginTop: "2px"
      },
      label: __spreadProps(__spreadValues({
        position: "absolute",
        pointerEvents: "none",
        width: "30px",
        textAlign: "center",
        transform: "translate(0, 22px)"
      }, theme.typography.body03), {
        color: theme.text.secondary,
        opacity: disabled ? theme.state.disabledOpacity : "100%"
      }),
      trackContainer: {
        position: "relative",
        width: "100%"
      },
      trackBase: {
        opacity: disabled ? theme.state.disabledOpacity : "100%",
        position: "absolute",
        height: size === "lg" ? "4px" : "2px"
      },
      selectedRange: {
        left: values.length === 1 ? 0 : `${minPercent}%`,
        // do not shift the selected range if slider is in single mode
        width: values.length === 1 ? `${maxPercent}%` : `${maxPercent - minPercent}%`,
        backgroundColor: theme.colorScheme.primary,
        borderRadius: "3px",
        zIndex: 2,
        visibility: values.length !== 2 ? "hidden" : "visible"
        // do not expose selectedRange for single slider until prop is added in v19+
      },
      track: {
        backgroundColor: theme.border.moderate,
        width: "100%",
        zIndex: 1
      },
      input: {
        [appearanceSelector]: "none",
        pointerEvents: "none",
        position: "absolute",
        height: 0,
        width: "100%",
        outline: "none",
        [thumbSelector]: {
          backgroundColor: `${theme.surface.primary}`,
          height: sliderSize,
          width: sliderSize,
          [appearanceSelector]: "none",
          border: `2px solid ${theme.colorScheme.primary}`,
          borderRadius: "50%",
          cursor: "pointer",
          marginTop: "4px",
          pointerEvents: "all",
          position: "relative",
          transform: size === "lg" ? "" : "translateY(-1px)"
        },
        "&:focus": {
          [thumbSelector]: {
            backgroundColor: theme.colorScheme.primary,
            border: `1px solid ${theme.surface.primary}`,
            boxShadow: `0 0 0 1px ${theme.colorScheme.primary}`,
            "&:active": {
              border: "none",
              boxShadow: "none",
              outline: "none"
            }
          }
        },
        "&:disabled": {
          [thumbSelector]: {
            borderColor: hexToRgb(
              `${theme.colorScheme.primary}`,
              `${theme.state.disabledOpacity}`
            ),
            pointerEvents: "none"
          }
        }
      }
    };
  }
);
function getDimensionBySize(size) {
  switch (size) {
    case "sm":
      return "12px";
    case "lg":
      return "20px";
    default:
      return "16px";
  }
}
function getPercent(value, min, max) {
  return (value - min) / (max - min) * 100;
}
export {
  getSliderBaseInputClassNames,
  getSliderBaseLabelMaxClassNames,
  getSliderBaseLabelMinClassNames,
  getSliderBaseLabelValueClassNames,
  getSliderBaseRootClassNames,
  getSliderBaseSelectedRangeClassNames,
  getSliderBaseTrackClassNames,
  getSliderBaseTrackContainerClassNames,
  sliderBaseDefaultProps,
  sliderBaseSizes,
  sliderBaseStyleSheet,
  sliderCommonDefaultProps,
  sliderDefaultProps,
  sliderMultipleDefaultProps,
  sliderMultipleSizes,
  sliderSizes
};
//# sourceMappingURL=index.mjs.map
